import { render, staticRenderFns } from "./PageItem.vue?vue&type=template&id=25c17184&"
import script from "./PageItem.vue?vue&type=script&lang=js&"
export * from "./PageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports